import React, { useReducer } from "react";

const Profile = (props) => {

    return (
        <div>
            <h2>Change your profile</h2>

            

            
        </div>
    )
}
export default Profile;